export function getCookieValue (a): any {
    const b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');

    return b ? b.pop() : null;
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/utils/get-cookie-value.ts